module.exports = __webpack_public_path__ + "img/portfolio-09-481x325.3702892e.jpg";